import { ref } from "vue";

export interface BatchRoleAssignmentResult {
  IsSimulation: boolean;
  Success: boolean;
  Errors: string[];
  ProcessedAt: string;
  FinishedAt: string;
  TotalUsersAssignment: number;
  TotalAssignments: number;
  AssignedRoles: {
    IsSuccess: boolean;
    FailureReason?: string;
    OrgCVR: string;
    OrganizationId: string;
    OrganizationName: string;
    Email: string;
    RoleName: string;
    RoleId: string;
  }[];
}

export default function useBatchRoleAssignmentSidebar() {
  const selectedResult = ref<BatchRoleAssignmentResult | null>(null);

  function showSidebar(result: BatchRoleAssignmentResult) {
    selectedResult.value = result;
  }

  function hideSidebar() {
    selectedResult.value = null;
  }

  return {
    selectedResult,
    showSidebar,
    hideSidebar,
  };
}
